import React, {Fragment} from "react";
import Sidebar from "../../components/Sidebar";
import NsAccordion from "../../components/accordion/NsAccordion";
import ContenutoModelliArchivioController from "./components/marche/ContenutoMarcheArchivioController";

export default function ArchivioMarcheView({
                                               title,
                                               isMobile,
                                               getAlberoStruttura,
                                               marche,
                                               handlerRefreshMarche,
                                               tipoVeicolo,
                                           }) {

    return (
        <Fragment>
            <div className={"container-fluid pt-3"}>
                <Fragment>
                    <Sidebar
                        sidebarContent={() => {
                            return isMobile ?
                                <NsAccordion
                                    titolo={'Struttura kpi'}
                                    label={'fas fa-stream'}>
                                    {
                                        getAlberoStruttura()
                                    }
                                </NsAccordion>
                                : getAlberoStruttura()
                        }}
                    >
                        <h4 className={"text-center"}>{title}</h4>
                        <hr className={"dropdown-divider"}/>
                        <ContenutoModelliArchivioController
                            marche={marche}
                            handlerRefreshMarche={handlerRefreshMarche}
                            tipoVeicolo={tipoVeicolo}
                        />
                    </Sidebar>
                </Fragment>
            </div>
        </Fragment>
    );
}